import { CentreBase, ModeratorInfo } from '@cambridgeassessment/lib-ee-commons';
import {
  PostResultsActionTypes,
  RESET_ALLOCATED_MODERATOR_STATE,
  RESET_CENTRE_STATE,
  RESET_CONSORTIUM_STATE,
  RESET_MODERATORS_STATE,
  SET_ALLOCATED_MODERATOR,
  SET_CENTRE,
  SET_CONSORTIUM,
  SET_FETCHING_CENTRE,
  SET_MODERATORS,
} from './types';

export const setCentre = (centre?: CentreBase[]): PostResultsActionTypes => ({
  type: SET_CENTRE,
  payload: centre,
});

export const resetCentreState = (): PostResultsActionTypes => ({
  type: RESET_CENTRE_STATE,
});

export const setConsortium = (centres: CentreBase[], consortiaName: string): PostResultsActionTypes => ({
  type: SET_CONSORTIUM,
  payload: { centres, consortiaName },
});

export const resetConsortiumState = (): PostResultsActionTypes => ({
  type: RESET_CONSORTIUM_STATE,
});

export const setAllocatedModerator = (moderator?: ModeratorInfo): PostResultsActionTypes => ({
  type: SET_ALLOCATED_MODERATOR,
  payload: moderator,
});

export const resetAllocatedModeratorState = (): PostResultsActionTypes => ({
  type: RESET_ALLOCATED_MODERATOR_STATE,
});

export const setModerators = (moderators: ModeratorInfo[]): PostResultsActionTypes => ({
  type: SET_MODERATORS,
  payload: moderators,
});

export const resetModeratorsState = (): PostResultsActionTypes => ({
  type: RESET_MODERATORS_STATE,
});

export const setFetchingCentre = (value: boolean): PostResultsActionTypes => ({
  type: SET_FETCHING_CENTRE,
  payload: value,
});
